// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text, NineSlicePlane } from 'pixi.js';
import type { OutOfLivesButtonView } from '../src/game/views/common/OutOfLivesButtonView';
import { ButtonLargeLayout } from './common/buttons/ButtonLargeLayout';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'e372f4ea-6e36-4c02-993f-c7193afe6317',
      type: 'Container',
      name: 'dioramaContainer',
      className: '',
      x: 0,
      y: -75,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '3acc236f-7282-4ec9-a0e2-cbd7a155f9ad',
      type: 'Container',
      name: 'collectionEventSlot',
      className: '',
      x: 0,
      y: 454,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '3a50dd3c-4fe1-4117-8f80-23d6e615ef00',
      type: 'Container',
      name: 'homePageUI',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '84667879-402d-412e-a206-95940930a7b7',
      type: 'Sprite',
      name: 'dioramaLight',
      className: '',
      x: 0,
      y: 8,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Light_Behind_Island',
      parent: 'e372f4ea-6e36-4c02-993f-c7193afe6317'
    },
    {
      id: '292012f3-d2ef-4cf1-aeb8-6444c1118326',
      type: 'Container',
      name: 'dioramaSlot',
      className: '',
      x: 0,
      y: 250,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: 'e372f4ea-6e36-4c02-993f-c7193afe6317'
    },
    {
      id: '17eb5972-5a85-4e16-91e5-1910f0754fd4',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -400,
      y: -77,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 800,
      height: 154,
      leftWidth: 51,
      topHeight: 51,
      rightWidth: 51,
      bottomHeight: 51,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collecting_Event_Progress_Bar_Background_Landscape_Mode_9Slice_51x51x51x51',
      parent: '3acc236f-7282-4ec9-a0e2-cbd7a155f9ad'
    },
    {
      id: '7ea76bac-68d5-45d1-b9a5-02f8b8152166',
      type: 'Container',
      name: 'eventIconsSlot',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 100,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3a50dd3c-4fe1-4117-8f80-23d6e615ef00',
      data: {
        dynamicValues: {
          x: 'width * -0.5 + 95'
        }
      }
    },
    {
      id: '69b76170-70e1-4c2f-8c71-5031bbb3ec9c',
      type: 'Container',
      name: 'resourceIconsSlot',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 100,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3a50dd3c-4fe1-4117-8f80-23d6e615ef00',
      data: {
        dynamicValues: {
          x: 'width * 0.5 - 80'
        }
      }
    },
    {
      id: 'c57feb2a-0ed9-4110-9634-cab7f0bfa3fb',
      type: 'Container',
      name: 'leaderboardSlot',
      className: '',
      x: 0,
      y: 470,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3a50dd3c-4fe1-4117-8f80-23d6e615ef00'
    },
    {
      id: '01552239-44de-4431-88b5-c3f665915c8d',
      type: 'Container',
      name: 'buttonContainer',
      className: '',
      x: 0,
      y: 608,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3a50dd3c-4fe1-4117-8f80-23d6e615ef00'
    },
    {
      id: '2525932f-e5c3-4a3d-b44a-f6b592028887',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: 180,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 177,
        y: 66
      },
      width: 354,
      height: 132,
      leftWidth: 55,
      topHeight: 55,
      rightWidth: 55,
      bottomHeight: 55,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Button_Background',
      parent: '01552239-44de-4431-88b5-c3f665915c8d'
    },
    {
      id: '444a9e10-7f73-4e10-8a43-950efe6d1280',
      type: 'Layout',
      name: 'dioramaButton',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 180,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: '01552239-44de-4431-88b5-c3f665915c8d',
      data: {
        color: 'blue',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: 'cd5b03db-d517-408e-9c08-7a272122d4f0',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -180,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 177,
        y: 66
      },
      width: 354,
      height: 132,
      leftWidth: 55,
      topHeight: 55,
      rightWidth: 55,
      bottomHeight: 55,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Button_Background',
      parent: '01552239-44de-4431-88b5-c3f665915c8d'
    },
    {
      id: '7151b058-0bdf-42a1-9dea-5438958a57f5',
      type: 'Layout',
      name: 'playButton',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: -180,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: '01552239-44de-4431-88b5-c3f665915c8d',
      data: {
        color: 'green',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '9c8a96dd-39a7-44f7-b1c6-63e3da006c6c',
      type: 'Container',
      runtimeType: 'OutOfLivesButtonView',
      name: 'outOfLivesButton',
      className: '',
      x: -180,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '01552239-44de-4431-88b5-c3f665915c8d'
    },
    {
      id: '10d68435-1037-4e37-bd00-2c492d65a3ac',
      type: 'Text',
      name: 'dioramaButtonText',
      className: '',
      x: -48,
      y: -19,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Island 1',
      localize: false,
      maxWidth: 165,
      maxHeight: 66,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#0147b1',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '444a9e10-7f73-4e10-8a43-950efe6d1280'
    },
    {
      id: '8786c9ee-47db-49b6-8f70-332b24af3b47',
      type: 'Container',
      name: 'dioramaProgressBar',
      className: '',
      x: -58,
      y: 22,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '444a9e10-7f73-4e10-8a43-950efe6d1280'
    },
    {
      id: '79ed5a39-4cc7-4d2f-9a7a-ff818f1dc104',
      type: 'Sprite',
      name: 'chestShadow',
      className: '',
      x: 88,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 87799,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Chest_Gold_White',
      parent: '444a9e10-7f73-4e10-8a43-950efe6d1280'
    },
    {
      id: '8a3e9ef4-d58d-4663-8b75-57440f86a0c5',
      type: 'Sprite',
      name: 'chest',
      className: '',
      x: 88,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Chest_Gold',
      parent: '444a9e10-7f73-4e10-8a43-950efe6d1280'
    },
    {
      id: 'b6fcbdbe-20ee-4e56-9344-c8bad33c2dc2',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: -13,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Play',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x00700c',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '7151b058-0bdf-42a1-9dea-5438958a57f5'
    },
    {
      id: 'b1ae8789-3e5a-4b00-b190-464e1963c5c7',
      type: 'Text',
      name: 'playButtonLevelText',
      className: '',
      x: 0,
      y: 26,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'LEVEL 20',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '0x00700c',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '7151b058-0bdf-42a1-9dea-5438958a57f5'
    },
    {
      id: '2d950c77-763b-490e-96da-526d03327644',
      type: 'NineSlicePlane',
      name: 'dioramaProgressBarBack',
      className: '',
      x: -74,
      y: -23,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 156,
      height: 35,
      leftWidth: 17,
      topHeight: 17,
      rightWidth: 17,
      bottomHeight: 17,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_Progress_Bar_Main_Menu_Empty_3Slice_17x17',
      parent: '8786c9ee-47db-49b6-8f70-332b24af3b47'
    },
    {
      id: '9404fdc9-ba74-43af-b389-344700b68245',
      type: 'NineSlicePlane',
      name: 'dioramaProgressBarFill',
      className: '',
      x: -72,
      y: -21,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 152,
      height: 31,
      leftWidth: 18,
      topHeight: 18,
      rightWidth: 18,
      bottomHeight: 18,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_Progress_Bar_Full_3Slice_18x18',
      parent: '8786c9ee-47db-49b6-8f70-332b24af3b47'
    },
    {
      id: 'f7f44300-7b0d-4202-9c29-90432fd9d6ec',
      type: 'Text',
      name: 'countText',
      className: '',
      x: 8,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '10/10',
      localize: false,
      maxWidth: 216,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '#8D2400',
        strokeThickness: 6,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '8786c9ee-47db-49b6-8f70-332b24af3b47'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  handleResize: false
} as const;

export class MainPageLayout {
  static raw = raw;
  root!: Container;
  dioramaContainer!: Container;
  collectionEventSlot!: Container;
  homePageUI!: Container;
  dioramaLight!: Sprite;
  dioramaSlot!: Container;
  eventIconsSlot!: Container & { data: typeof raw['list'][7]['data'] };
  resourceIconsSlot!: Container & { data: typeof raw['list'][8]['data'] };
  leaderboardSlot!: Container;
  buttonContainer!: Container;
  dioramaButton!: ButtonLargeLayout & { data: typeof raw['list'][12]['data'] };
  playButton!: ButtonLargeLayout & { data: typeof raw['list'][14]['data'] };
  outOfLivesButton!: OutOfLivesButtonView;
  dioramaButtonText!: Text;
  dioramaProgressBar!: Container;
  chestShadow!: Sprite;
  chest!: Sprite;
  playButtonLevelText!: Text;
  dioramaProgressBarBack!: NineSlicePlane;
  dioramaProgressBarFill!: NineSlicePlane;
  countText!: Text;
  dynamicProps_SPL!: (Container & { data: typeof raw['list'][7]['data'] } | Container & { data: typeof raw['list'][8]['data'] })[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
